import { cn } from '@ifixit/ui/lib/utils';

// Stand-in for a supply with no image: a centered "no image" glyph so the row
// stays aligned and reads as a supply rather than a blank gap. Drawn as an
// inline SVG (matching the vanilla *-thumb-empty background) because the embed's
// legacy icomoon font ships no image glyph. Shared by the intro supply grid and
// the rail's tools/parts list.
export function NoImageThumb({ className }: { className?: string }) {
   return (
      <span
         aria-hidden
         className={cn('flex-none rounded-md border border-gray-300 bg-gray-800/5', className)}
         style={{
            backgroundImage:
               "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%239aa0a6' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='3' width='18' height='18' rx='2' ry='2'/%3E%3Ccircle cx='8.5' cy='8.5' r='1.5'/%3E%3Cpolyline points='21 15 16 10 5 21'/%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: '60%',
         }}
      />
   );
}
